import { render, staticRenderFns } from "./ADpost.vue?vue&type=template&id=7d982252"
import script from "./ADpost.vue?vue&type=script&lang=js"
export * from "./ADpost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports